module.exports = __webpack_public_path__ + "img/Rajouter.2f717147.png";